export default __webpack_public_path__ + "static/media/Confused.1012623d.svg";